@let locked = (locked$ | async);
<div>
  <div #shopOrder class="pb-3 py-3 reletive" (click)="selectedService !== null ? this.selectedService = null : null">
    <div class="">
      <div class="head-label-wr relative">
        @if(currentShopOrder){
          <button class="back-btn" [routerLink]="['/', userIndex, 'shop']">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <h3 class="head-label">Shop #{{ currentShopOrder?.orderNumber }}</h3>
          <div class="created">
            <span>Last Modified: {{ $safeNavigationMigration(currentShopOrder?.updated?.at) | date: 'short' }}</span>
            <app-account-info-popover [position]="'BOTTOM'" [creator]="$safeNavigationMigration(currentShopOrder?.updated?.by)"></app-account-info-popover>
          </div>
          <button class="shop-order-action" [popper]="orderAction" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.LEFT" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
            <i class="fa-solid fa-bolt"></i>
          </button>
          <popper-content #orderAction class="z-50">
            <div class="shadow-lg orderAction-popover border border-gray-100 rounded-lg bg-white">
              <button (click)="orderAction.hide()" [routerLink]="['/', userIndex, 'shop', currentShopOrder._id, 'history']" title="Show History">
                <i id="history-link-i" class="fas fa-history"></i>
                <span>Show History</span>
              </button>
              <button *appHasPermission="'shop_create'" type="button" title="Clone Work Order" class="" (click)="clone(); orderAction.hide()">
                <i class="far fa-copy"></i>
                <span>Clone Shop Order</span>
              </button>
              @if(currentShopOrder?._gen_pdf){
                <button (click)="orderAction.hide()" class="btn btn-sm btn-outline-secondary mr-3">
                  <i class="fas fa-spinner fa-pulse"></i>
                  <span>Loading...</span>
                </button>
              }@else {
                <button type="button" title="Generate PDF" class="" (click)="generatePdf(); orderAction.hide()">
                  <i class="fa-solid fa-file-pdf"></i>
                  <span>Generate PDF</span>
                </button>
                <button type="button" title="Get Blank" class="" (click)="generateBlank(); orderAction.hide()">
                  <i class="fa-regular fa-file-pdf"></i>
                  <span>Get Blank PDF</span>
                </button>
              }
              @if(!locked){
                <button type="button" *appHasPermission="'shop_delete'" title="Delete ShopOrder" class="border-t border-gray-100" (click)="deleteShopOrder(); orderAction.hide()">
                  <i class="fas fa-trash delete-action-icon"></i>
                  <span class="delete-action-text">Delete Shop Order</span>
                </button>
              }
            </div>
          </popper-content>
        }@else {
          <div class="w-1/2">
            <app-preloader [type]="'LARGE_LIST'" [count]="1" [customHeight]="'40px'"></app-preloader>
          </div>
        }
      </div>
    </div>
    <div class="flex shop_contact">
      <div class="shop-cont-left">
        <div class="shop-contact-details h-full">
          <div class="shop-contact-wr">
            <div class="rounded-lg shop-det relative">
              <p class="title-det absolute">Shop</p>
              @if(currentShopOrder?._id){
                <div class="shop-item-shop relative" [ngClass]="{'shop-item-no-content': !currentShopOrder?.shop?._id}">
                  @if (!locked) {
                    @if(currentShopOrder?.shop?._id){
                    <i class="fa-solid fa-shop shop-item-icon"></i>
                    }
                  }
                  @if (!locked) {
                    <div class="delete-acc">
                      @if(currentShopOrder?.shop?._id){
                        <app-btn-confirm *appHasPermission="'shop_update'"
                          (onConfirm)="removeShop($safeNavigationMigration(currentShopOrder?._shop))"
                          [id]='"-currentShopOrder"'
                        ></app-btn-confirm>
                      }
                    </div>
                  }
                  @if(currentShopOrder?.shop?._id){
                    <div class="info-det">
                      <div class="info-det-left">
                        <div class="info-det-item">
                          <p class="titles"><i class="fa-solid fa-shop shop-item-icon-small"></i>Shop</p>
                          <p class="velues">{{currentShopOrder?._shop?.name}}</p>
                        </div>
                        <div class="info-det-item">
                          <p class="titles">Address</p>
                          <p class="velues">{{currentShopOrder?._shop?.address?.addressLine1}}</p>
                        </div>
                      </div>
                      <div class="info-det-right">
                        <div class="info-det-item">
                          <p class="titles">Type</p>
                          <p class="velues">{{currentShopOrder?._shop?.type}}</p>
                        </div>
                        @if(currentShopOrder?._shop?.phones?.length){
                          <div class="info-det-item">
                            <p class="titles">Phones</p>
                            @for (phone of currentShopOrder?._shop?.phones; track $index) {
                              <input class="values-input border-none p-0" [disabled]="true" [ngModel]="maskTransform($safeNavigationMigration(phone?.value), {mask: inputMasks[type]})" />
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }@else {
                    <div class="w-full">
                      <div class="title-edits">Truck Shop</div>
                      <app-search
                        [idInfo]="'truck-shop'"
                        [label]="'Select Truck Shop'"
                        [resource]="'CONTACT'"
                        [isReadOnly]="locked"
                        [method]="'search'"
                        [filter]="{type: 'TRUCK SHOP', limit: 25, sort: 'quoteCount', dir: 'desc', active: true, isAccount: true}"
                        (onChange)="setShop($event._id, $event.name)"
                      ></app-search>
                    </div>
                  }
                </div>
              }@else {
                <div class="p-2">
                  <app-preloader [type]="'LARGE_LIST'" [count]="2" [customHeight]="'40px'"></app-preloader>
                </div>
              }
            </div>
            <div class="customer-det rounded-lg relative">
              <p class="title-det absolute">Customer</p>
              @if(currentShopOrder?._id){
                <div class="shop-item flex relative" [ngClass]="{'shop-item-no-content': !currentShopOrder?.customerId}">
                  <div class="delete-acc">
                    @if (!locked && currentShopOrder?.customerId && !services()?.length) {
                      <app-btn-confirm
                        *appHasPermission="'shop_update'"
                        (onConfirm)="removeCustomer($safeNavigationMigration(currentShopOrder?.customerId))"
                        [id]='"-currentShopOrder"'
                      ></app-btn-confirm>
                    }
                  </div>
                  @if(currentShopOrder?.customerId){
                    <i class="fa-solid fa-user shop-item-icon"></i>
                    <div class="info-det">
                      <div class="info-det-left">
                        <div class="info-det-item">
                          <p class="titles"><i class="fa-solid fa-user shop-item-icon-small"></i>Customer</p>
                          <p class="velues">{{currentShopOrder?._customer?.name}}</p>
                        </div>
                        <div class="info-det-item">
                          <p class="titles">Email</p>
                          @for(email of currentShopOrder?._customer?.emails; track $index) {
                            <p class="velues velues-email">{{email?.value}}</p>
                          }
                        </div>
                        <div class="info-det-item">
                          <p class="titles">Address</p>
                          <p class="velues">{{currentShopOrder?._customer?.address?.addressLine1}}</p>
                        </div>
                      </div>
                      <div class="info-det-right">
                        <div class="info-det-item">
                          <p class="titles">Type</p>
                          <p class="velues">{{currentShopOrder?._customer?.type}}</p>
                        </div>
                        @if(currentShopOrder?._customer?.phones?.length){
                          <div class="info-det-item flex flex-col">
                            <p class="titles">Phones</p>
                            @for (phone of currentShopOrder?._customer?.phones; track $index) {
                              <input class="values-input border-none p-0" [disabled]="true" [ngModel]="maskTransform($safeNavigationMigration(phone?.value), {mask: inputMasks[type]})" />
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }@else {
                    <div class="w-full">
                      <div class="title-edits">Truck Shop</div>
                      <app-search
                        *appHasPermission="'shop_update'"
                        [idInfo]="'customerId'"
                        [label]="'Select'"
                        [resource]="'CONTACT'"
                        [isReadOnly]="locked"
                        [method]="'search'"
                        [filter]="{limit: 25, sort: 'quoteCount', dir: 'desc', active: true, isAccount: true}"
                        (onChange)="setCustomer($event._id)"
                      ></app-search>
                    </div>
                  }

                </div>
              }@else {
                <div class="p-2">
                  <app-preloader [type]="'LARGE_LIST'" [count]="3" [customHeight]="'40px'"></app-preloader>
                </div>
              }
            </div>
            <div class="rounded-lg transport-type-det relative">
              <p class="title-det absolute">Truck - Trailer</p>
              @if(currentShopOrder?._id){
                <div class="shop-item-padd relative" [ngClass]="{'block truck-trailer-ampty-wr': !currentShopOrder?.customerId || !currentShopOrder?._units?.length, 'pr-3': currentShopOrder?._units?.length === 1}">
                  @if(!currentShopOrder?.customerId){
                    <div class="truck-trailer-ampty">
                      <p class="whitespace-nowrap">Please Select a</p>
                      <label for="customerId-search-input" class="add-customers">Customer</label>
                    </div>
                  }
                  @if(services()?.length && currentShopOrder?._units?.length && !locked){
                    <button *appHasPermission="'shop_update'" [disabled]="locked" (click)="editUnit = !editUnit" class="change-units text-gray-900 font-medium">{{!editUnit?'Change':'Back'}}</button>
                  }
                  @if((!currentShopOrder?._units?.length || editUnit) && currentShopOrder?.customerId){
                    <div class="editUnits w-full">
                      <p class="title-edits">Change Unit</p>
                      @if(editUnit){
                        <app-search
                          [idInfo]="'equipment-search'"
                          *appHasPermission="'shop_update'"
                          [label]="'Unit'"
                          [resource]="'EQUIPMENT'"
                          [options]="{focus: true}"
                          [method]="'search'"
                          [filter]="{carrierId: currentShopOrder.customerId}"
                          (onChange)="replaceUnit($event)"
                        ></app-search>
                      }@else if(!currentShopOrder?._units?.length){
                        <app-search
                          [idInfo]="'equipment-search'"
                          *appHasPermission="'shop_update'"
                          [label]="'Unit'"
                          [resource]="'EQUIPMENT'"
                          [options]="{focus: true}"
                          [method]="'search'"
                          [filter]="{carrierId: currentShopOrder.customerId}"
                          (onChange)="setUnit($event)"
                        ></app-search>
                        @if(quickBooksShopConnected$ | async){
                          <p class="qb-invoices-hint qb-truck-hint">Add a truck to invoice this order in QuickBooks.</p>
                        }
                      }
                    </div>
                  }
                  @if(!editUnit && currentShopOrder?.customerId && currentShopOrder?._units?.length){
                    <div class="item_units-wr">
                      @for (unit of $safeNavigationMigration(currentShopOrder?._units) | sort : 'equipmentType': { reverse: true }; track $index) {
                        <div class="shop-item_units">
                          <i class="fa-solid shop-item-icon" [ngClass]="{'fa-truck': unit?.equipmentType == 'TRUCK', 'fa-trailer': unit?.equipmentType == 'TRAILER'}"></i>
                          <div class="info-det relative">
                            <div class="">
                              <div class="info-det-item">
                                @if(unit?.equipmentType == 'TRUCK'){
                                  <p class="titles"><i class="fa-solid fa-truck shop-item-icon-small"></i>Truck</p>
                                }@else if(unit?.equipmentType == 'TRAILER'){
                                  <p class="titles"><i class="fa-solid fa-trailer shop-item-icon-small"></i>Trailer</p>
                                }
                                <p class="velues">{{unit?.year}} {{unit?.make}} {{unit?.model}}</p>
                              </div>
                              @if(unit.registrationNumber){
                                <div class="info-det-item">
                                  <p class="titles">Plate</p>
                                  <p class="velues">{{unit?.registrationNumber}}</p>
                                </div>
                              }
                              @if(unit?.VIN){
                                <div class="info-det-item">
                                  <p class="titles">Unit</p>
                                  <p class="velues">{{unit?.details}} {{unit?.equipmentType}}</p>
                                </div>
                                <div class="info-det-item">
                                  <p class="titles">VIN</p>
                                  <p class="velues">{{unit?.VIN}}</p>
                                </div>
                              }
                              @if(unit.registrationNumber){
                                <div class="info-det-item">
                                  <p class="titles">Plate</p>
                                  <p class="velues">{{unit?.registrationNumber}}</p>
                                </div>
                              }
                            </div>
                            @if(!services()?.length && !locked){
                              <app-btn-confirm *appHasPermission="'shop_update'" class="href position-absolute" style="right:10px; top:-4px"
                              [isReadOnly]="locked"(onConfirm)="removeUnit($safeNavigationMigration(unit?._id))"></app-btn-confirm>
                            }
                          </div>
                        </div>
                      }
                      @if(!editUnit && currentShopOrder.unit.length===1 && currentShopOrder?._linkedUnit[0]?._id){
                        <div class="flex items-center flex-1">
                          <button class="add-unit-btns" (click)="setUnit({
                              _id:currentShopOrder._linkedUnit[0]._id,
                              name:$safeNavigationMigration(currentShopOrder._linkedUnit[0]?.details) + '-' + $safeNavigationMigration(currentShopOrder._linkedUnit[0]?.make) + $safeNavigationMigration(currentShopOrder._linkedUnit[0]?.model) + $safeNavigationMigration(currentShopOrder._linkedUnit[0]?.year),
                              equipmentType: currentShopOrder._linkedUnit[0].equipmentType
                            })">
                            Add {{currentShopOrder._linkedUnit[0].equipmentType}} (Unit {{currentShopOrder._linkedUnit[0]?.details}})
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- Shop QuickBooks customer the truck's invoices bill (one per truck, chosen by hand); hidden
                     while the link of a just-changed truck is still loading -->
                @let qbCustomer = (qbCustomer$ | async);
                @let qbCustomerSaving = (qbCustomerSaving$ | async);
                @let qbShopConnected = (quickBooksShopConnected$ | async);
                <!-- Disconnected: the truck's customer is still shown, read only -->
                @if((qbShopConnected || qbCustomer?.qbCustomer) && currentShopOrder?.customerId){
                  <!-- No units at all: the hint sits under the Unit search instead (this card's empty state fills it) -->
                  @if(!orderTruckId){
                    @if(currentShopOrder?._units?.length && qbShopConnected){
                      <p class="qb-customer qb-invoices-hint">Add a truck to invoice this order in QuickBooks.</p>
                    }
                  } @else if(qbCustomer?.truck?._id === orderTruckId){
                    <div class="qb-customer">
                      @if(qbCustomer.qbCustomer){
                        <div class="qb-customer-linked">
                          <app-input
                            [readView]="true"
                            [label]="'QuickBooks customer (truck ' + qbCustomer.truck.unitNumber + ')'"
                            [value]="'[' + qbCustomer.qbCustomer.qbId + '] ' + qbCustomer.qbCustomer.name"
                          ></app-input>
                          @if(canUpdate && qbShopConnected){
                            <div class="qb-customer-actions">
                              <button type="button" title="Unlink" [disabled]="qbCustomerSaving" (click)="unlinkQuickBooksCustomer(qbCustomer)">
                                <i class="fa-solid fa-xmark"></i>
                              </button>
                            </div>
                          }
                        </div>
                      } @else if(canUpdate && qbShopConnected){
                        <app-search
                          [label]="'QuickBooks customer for truck ' + qbCustomer.truck.unitNumber"
                          [resource]="'QUICK_BOOK'"
                          [method]="'shopCustomerSearch'"
                          [idInfo]="'shop-qb-customer'"
                          [isReadOnly]="qbCustomerSaving"
                          [filter]="{}"
                          (onChange)="changeQuickBooksCustomer({ type: 'link', qbCustomerId: $event.Id })"
                        ></app-search>
                      } @else if(qbShopConnected){
                        <p class="qb-invoices-hint">Truck {{ qbCustomer.truck.unitNumber }} has no QuickBooks customer yet.</p>
                      }
                    </div>
                  }
                }
              }@else {
                <div class="p-2">
                  <app-preloader [type]="'LARGE_LIST'" [count]="4" [customHeight]="'40px'"></app-preloader>
                </div>
              }
            </div>
          </div>
          <div class="searct_units_wr">
            <div class="searct-service-det rounded-lg">
              <div class="relative search-all-services">
                <app-input
                  (onInput)="searchService($event)"
                  [value]="filterValue()"
                  [icon]="'fa-solid fa-magnifying-glass text-gray-500'"
                  [options]="{
                    borderNone: true
                  }"
                  [placeholder]="'Search by description'"
                  id="shop-item-search"
                >
                </app-input>
              </div>
            </div>
            @if(!editUnit){
              <div class="odometer-det shop-item rounded-lg flex items-center justify-between">
                @if(currentShopOrder?._id) {
                  <app-input [title]="'Odometer'" [isReadOnly]="locked || !canUpdate" [value]="currentShopOrder?.odometer ? $safeNavigationMigration(currentShopOrder?.odometer?.toString()) : '0'" [label]="'Odometer'"
                  [type]="'float-number'" [options]="{borderNone: true}" (onSave)="setOdometer($event)"></app-input>

                  <div class="flex items-center justify-between">
                    @if(currentShopOrder?._prevOdometer){
                      <span class="Last-WO">Last WO {{$safeNavigationMigration(currentShopOrder?._prevOdometer) | number}}</span>
                    }
                    @if(currentShopOrder?._realOdometer?.value){
                      <button class="realOdometer-location" [popper]="_prevOdometer" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.TOP" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
                        <i class="fa-solid fa-location-crosshairs"></i>
                      </button>
                    }
                    <popper-content #_prevOdometer class="z-50">
                      <div  class="current-odometer-popover shadow-lg">
                        <div class="title">
                          <i class="fa-solid fa-location-crosshairs"></i>
                          <span>Current Odometer</span>
                        </div>
                        @if(currentShopOrder?._realOdometer?.value){
                          <div class="pop-content">
                            <span>ODO: <b>{{$safeNavigationMigration(currentShopOrder?._realOdometer?.value) | number}} mi</b></span>
                            <span>({{$safeNavigationMigration(currentShopOrder?._realOdometer?.time) | date: 'short'}})</span>
                            @if(!currentShopOrder?.odometer){
                              <button class="set_realOdometer" [disabled]="locked" (click)="setOdometer($safeNavigationMigration(currentShopOrder?._realOdometer?.value))">Set</button>
                            }
                          </div>
                        }
                      </div>
                    </popper-content>
                  </div>
                }@else {
                  <div class="w-100">
                    <app-preloader [type]="'LARGE_LIST'" [count]="1" [customHeight]="'40px'"></app-preloader>
                  </div>
                }
              </div>
            }

          </div>
          <div [hidden]="!selectedServices?.length" class="selected-det w-full rounded-lg block">
            <div class="selected w-full">
              <div class="inner w-full">
                <div class="selected-list">
                  @for(service of selectedServices; track $index){
                    <span class="selected-order bg-red-100 font-medium"
                    [ngClass]="{
                      'text-red-900 bg-red-100': service?.status?.toLocaleLowerCase() === 'new',
                      'text-yellow-900 bg-yellow-100': service?.status?.toLocaleLowerCase() === 'active',
                      'text-green-900 bg-green-100': service?.status?.toLocaleLowerCase() === 'completed',
                      'text-gray-900 bg-gray-100': service?.status?.toLocaleLowerCase() === 'closed'
                    }"
                    >{{!service.desc ? 'Without Desc' : service?.desc?.length > 50 ? service?.desc.slice(0, 50) + '...' : service?.desc}}
                      <i class="fas fa-times ml-2" (click)="selectService(service)"></i>
                    </span>
                  }
                </div>
                <div class="order-actions justify-end">
                  <app-select
                    *appHasPermission="'shop_update'"
                    [label]="'Status'"
                    (onSave)="setServicesStatus($event)"
                    [value]="''"
                    [idInfo]="'setServicesStatus'"
                    [list]="statuses"
                    [keyName]="{key:'_id', name:'name'}"
                    [placeholder]="'Select Status'"
                    [options]="{noFirstOption: true}"
                  ></app-select>

                  <button
                    *appHasPermission="'shop_create'"
                    class="border order-actions-item move-new-order border-gray-200 text-gray-900"
                    (click)="moveServices()"
                  >
                    Move to New Order
                  </button>

                  <button
                   *appHasPermission="'shop_update'"
                    class="delete order-actions-item"
                    title="Delete"
                    (click)="deleteAllSelectedService()"
                  >Delete</button>

                  <button
                    class="unselect order-actions-item"
                    title="Unselect all selected orders"
                    (click)="unselectAllSelectedService()"
                  >Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shop-cont-right rounded-lg shop-item flex-col">
        @if(currentShopOrder?._id){
          <button [disabled]="locked || !canUpdate" class="selectedStatus-btn" #selectedStatusBtn [popper]="selectedStatus" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.BOTTOM" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
            <span
              [ngClass]="{
                'text-red-900 bg-red-100': currentShopOrder?.status === 'NEW',
                'text-yellow-900 bg-yellow-100': currentShopOrder?.status === 'ACTIVE',
                'text-green-900 bg-green-100': currentShopOrder?.status === 'COMPLETED',
                'text-gray-900 bg-gray-100': currentShopOrder?.status === 'CLOSED',
                'text-amber-900 bg-amber-100': currentShopOrder?.status === 'ON_HOLD'
              }"
            >{{currentShopOrder?.status === 'ON_HOLD' ? 'ON-HOLD' : currentShopOrder?.status}}</span>
            <i *appHasPermission="'shop_update'" class="fa-solid" [ngClass]="[selectedStatusContent.offsetWidth !== 0 ? 'fa-caret-up' : 'fa-caret-down']"></i>
          </button>
          <popper-content #selectedStatus class="z-50">
            <div #selectedStatusContent class="shadow-lg selectedStatus-popover border border-gray-100 rounded-lg bg-white flex flex-col" [ngStyle]="{'min-width': selectedStatusBtn.offsetWidth+'px'}">
              <button (click)="setStatus('NEW')">NEW</button>
              <button (click)="setStatus('ON_HOLD')">ON-HOLD</button>
              <button (click)="setStatus('ACTIVE')">ACTIVE</button>
              <button (click)="setStatus('COMPLETED')">COMPLETED</button>
              <button (click)="setStatus('CLOSED')">CLOSED</button>
            </div>
          </popper-content>

          <div class="refNumber-wr shop-cont-right-item">
            <span class="block title font-medium text-gray-900 dark:text-white">REF Number</span>
            <app-input
              [isReadOnly]="locked || !canUpdate"
              (onSave)="updateShopOrder({_id:$safeNavigationMigration(currentShopOrder?._id), refNumber: $event})"
              [value]="$safeNavigationMigration(currentShopOrder?.refNumber)"
              [options]="{borderNone: true}"
              [placeholder]="'type here...'"
            ></app-input>
          </div>
          @if(!currentShopOrder?.driverId && currentShopOrder?.customerId && !locked){
            <div class="shop-cont-right-item">
              <app-search
                [idInfo]="'driver'"
                [label]="'Driver'"
                [resource]="'CONTACT'"
                [options]="{borderNone: true}"
                [isReadOnly]="locked || !canUpdate"
                [method]="'search'"
                [filter]="{accountId: $safeNavigationMigration(currentShopOrder?.customerId), type: 'DRIVER', limit: 25, sort: 'quoteCount', dir: 'desc', active: true, isAccount: false}"
                (onChange)="setDriver($event._id)"
              ></app-search>
            </div>
          }@else if (currentShopOrder?.driverId) {
            <div class="shop-cont-right-item">
              <span class="block title font-medium text-gray-900 dark:text-white">Driver</span>
              <app-input
                [isReadOnly]="true"
                [disabled]="locked || !canUpdate"
                [options]="{canRemove: !locked && canUpdate, borderNone: true}"
                (onRemove)="!locked ? setDriver(null) : null"
                [value]="$safeNavigationMigration(currentShopOrder?._driver?.name)"
              ></app-input>
            </div>
          }
          @if(currentShopOrder?.driverId){
            <div class="shop-cont-right-item">
              <span class="block title font-medium text-gray-900 dark:text-white">Created By</span>
              <app-input
                [isReadOnly]="true"
                (onRemove)="setDriver(null)"
                [options]="{borderNone: true}"
                [value]="$safeNavigationMigration(currentShopOrder?.creator?.name)"
              ></app-input>
            </div>
          }
          <div class="shop-cont-right-item">
            <span class="block title font-medium text-gray-900 dark:text-white">Created</span>
            <app-date [title]="'Created'" [options]="{borderNone: true, disabled:true, fullFormat: true}" class="due-by-date" [startKey]="'createdAt'"
            [parent]="currentShopOrder"></app-date>
          </div>
          <div class="shop-cont-right-item">
            <div class="dates-wr">
              <div class="dates-item">
                <span class="block title font-medium text-gray-900 dark:text-white">Arrival:</span>
                <app-date [options]="{disabled:locked || !canUpdate, borderNone: true, fullFormat: true}" class="due-by-date" [startKey]="'arrivalDate'" [parent]="currentShopOrder"
                (onSave)="updateShopOrder($event)"></app-date>
              </div>
              <div class="dates-item">
                <span class="block title font-medium text-gray-900 dark:text-white">Depart:</span>
                <app-date [options]="{disabled:locked || !canUpdate, borderNone: true, fullFormat: true}" [startKey]="'departureDate'" [parent]="currentShopOrder"
                (onSave)="updateShopOrder($event)"></app-date>
              </div>
            </div>
          </div>

          <div class="shop-cont-right-item">
            <div class="dates-wr">
              <div class="dates-item">
                <span class="block title font-medium text-gray-900 dark:text-white">Invoice Date</span>
                <app-date class="due-by-date" [startKey]="'invoiceDate'" [parent]="currentShopOrder.accounting"
                [options]="{disabled:locked || !canUpdate, borderNone: true, fullFormat: true}" (onSave)="setAccounting('invoiceDate', $event.invoiceDate)"></app-date>
              </div>
              <div class="dates-item">
                <span class="block title font-medium text-gray-900 dark:text-white">Completed</span>
                <app-date [options]="{disabled:locked || !canUpdate, borderNone: true, fullFormat: true}" [title]="'Completed'" [startKey]="'completedAt'"
                [parent]="currentShopOrder" (onSave)="updateShopOrder($event)"></app-date>
              </div>
            </div>
          </div>
        }@else {
          <div class="w-100">
            <app-preloader [type]="'LARGE_LIST'" [count]="7" [customHeight]="'40px'"></app-preloader>
          </div>
        }
      </div>
    </div>
    <div>
      <table class="custom-table w-full overflow-visible" [ngStyle]="{'pointer-events': locked ? 'none' : null}">
        <thead>
          <tr>
            @if(!locked){
              <th style="width: 10px;"></th>
            }
            <th style="width: 30px;">
              <input
                type="checkbox"
                [disabled]="locked"
                placeholder="Enter Text"
                (change)="onSelectAll()"
                [checked]="_services().length && selectedServices.length == _services().length"
                class="custom-checkbox w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded"
              />
            </th>
            <th style="width: 30px;">#</th>
            <th>STATUS</th>
            <th>SERVICE</th>
            <th>TYPE</th>
            <th>DESCRIPTION</th>
            <th>HRS/QTY</th>
            <th>RATE</th>
            <th>AMOUNT</th>
            <th>MECHANIC</th>
            <th>UNIT</th>
            <th style="width: 60px;">DOCS</th>
          </tr>
        </thead>
        <tbody [nxtSortablejs]="_services()" [config]="sortableOptions">
          @if(currentShopOrder?._id){
            @for(service of _services() | sort: 'index'; track service._id){
              <tr
                [ngClass]="{'not-drag': locked || filterValue(), 'service_item': selectedService?._id !== service?._id, 'service-row-edit': selectedService?._id === service?._id, 'service-row-new': isAddedAfterInvoice(service) || isChangedAfterInvoice(service)}"
                [title]="isAddedAfterInvoice(service) ? 'Added after the order was invoiced: not on a QuickBooks invoice yet' : isChangedAfterInvoice(service) ? 'Changed since it was invoiced: open the invoice to update it' : ''"
                (mousedown)="onMouseDown($event)"
                (mousemove)="onMouseMove($event)"
                (click)="toggleEditMode(service, $event)"
              >
                @if(!locked){
                  <td class="text-center" [ngClass]="{
                    'not-to-drag': filterValue()
                  }">
                    <span class="drag-icon">
                      <i class="fas fa-ellipsis-v cursor-grabbing drag-dot"></i>
                      <i class="fas fa-ellipsis-v cursor-grabbing drag-dot"></i>
                    </span>
                  </td>
                }
                <td class="not-drag service-cell-icon" (click)="$event.stopPropagation();">
                  @if(locked){
                    <span class="lock-stop-icon">
                      <i class="fas fa-lock"></i>
                    </span>
                  }@else {
                    <input
                      class="custom-checkbox w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded ml-[10px]"
                      type="checkbox"
                      placeholder="Enter Text"
                      [checked]="$safeNavigationMigration(service?._selected)"
                      (change)="selectService(service);"
                    />
                  }
                </td>
                <td class="text-center not-drag">
                  {{service?.index}}
                </td>
                <td class="table-status-wr not-drag service-cell-icon">
                  @if(selectedService?._id !== service?._id) {
                    <span
                      class="table-status"
                      [ngClass]="{
                        'text-red-900 bg-red-100': service?.status === 'NEW',
                        'text-yellow-900 bg-yellow-100': service?.status === 'ACTIVE',
                        'text-green-900 bg-green-100': service?.status === 'COMPLETED',
                        'text-gray-900 bg-gray-100': service?.status === 'CLOSED',
                        'text-orange-900 bg-orange-100': service?.status === 'ON_HOLD'
                      }">
                      {{service?.status}}
                    </span>
                  }
                  <div (click)="handleClick($event)">
                    @if(selectedService?._id == service?._id){
                      <app-select
                        [keyName]="{key:'_id', name:'name'}"
                        (onSave)="updateService({_id:service._id, status: $event}); service.status = $event"
                        [value]="$safeNavigationMigration(service?.status)"
                        [idInfo]="'edit-status-service'"
                        [list]="statuses"
                        [placeholder]="'Select Status'"
                        [options]="{noFirstOption: true, borderNone: true, appendToBody: true}"
                      ></app-select>
                    }
                  </div>
                </td>
                <td class="table-serviceType-wr not-drag">
                  @if(service?.serviceType && (selectedService?._id !== service?._id)){
                    <div class="table-serviceType">
                      <p class="whitespace-nowrap w-fit">{{serviceTypes[service?.serviceType]}}</p>
                    </div>
                  }

                  <div (click)="handleClick($event)">
                    @if(selectedService?._id == service?._id){
                      <app-select
                        [keyName]="{key:'_id', name:'name'}"
                        (onSave)="updateService({_id:service._id, serviceType: $event}); service.serviceType = $event"
                        [idInfo]="'edit-status-service'"
                        [value]="$safeNavigationMigration(service?.serviceType)"
                        [list]="currentServiceTypes"
                        [placeholder]="'Select Status'"
                        [options]="{noFirstOption: true, borderNone: true, appendToBody: true}"
                      ></app-select>
                    }
                  </div>
                </td>
                <td class="table-type not-drag">
                  @if(selectedService?._id !== service?._id){
                    <div class="table-item-view cursor-default whitespace-nowrap">
                      <i class="fa-solid" [ngClass]="{'fa-hand': service?.type == 'LABOR', 'fa-gears': service?.type == 'PART'}"></i>
                      @if(service?.type == 'LABOR'){
                        <span>Labor</span>
                      }@else if(service?.type == 'PART'){
                        <span>Parts</span>
                      }
                    </div>
                  }
                  <div (click)="handleClick($event)">
                    @if(selectedService?._id == service?._id){
                      <app-select
                        [list]="[{key:'LABOR', name: 'Labor'}, {key:'PART', name: 'Part'}]"
                        [value]="$safeNavigationMigration(service?.type)"
                        [options]="{noFirstOption: true, borderNone: true, appendToBody: true}"
                        [placeholder]="'Select'"
                        (onSave)="setServiceType(service, $event)"
                      ></app-select>
                    }
                  </div>
                </td>
                <td class="table-description-rw not-drag">
                  @if(selectedService?._id == service?._id){
                    <div>
                      <!-- Part rows: one field that searches the QuickBooks catalog and also takes free text; a part
                           picked from QuickBooks shows read only, removed to pick another or type a custom one -->
                      @if(qbConnected() && service?.type !== 'LABOR' && service?.qbItem?.qbId){
                        <div class="mt-2 mb-1" (click)="handleClick($event)">
                          <app-input
                            [value]="service?.desc || ''"
                            [isReadOnly]="true"
                            [display]="{ remove: !locked && canUpdate }"
                            [options]="{ borderNone: true, canRemove: !locked && canUpdate }"
                            [idInfo]="'shop-part-' + service._id"
                            (onRemove)="removeServiceQbItem(service)"
                          ></app-input>
                        </div>
                      } @else if(qbConnected() && service?.type !== 'LABOR' && !isMultilineCustomPart(service)){
                        <div class="mt-2 mb-2" (click)="handleClick($event)">
                          <app-search
                            [resource]="'SHOP_PART'"
                            [method]="'shopPartSearch'"
                            [idInfo]="'shop-part-' + service._id"
                            [filter]="{}"
                            [fieldText]="service?.desc || ''"
                            [isReadOnly]="locked || !canUpdate"
                            [debounceTime]="300"
                            [options]="{ borderNone: true, appendToBody: true, focus: true, keepText: true, compact: true, placeholderText: 'Part number or description' }"
                            (onType)="onPartTextChange(service, $event)"
                            (onChange)="setServiceQbItem(service, $event)"
                          ></app-search>
                        </div>
                      } @else {
                        <textarea
                          [value]="service?.desc || ''"
                          (input)="onDescChange($event, service); service.desc = $any($event.target).value"
                          (click)="handleClick($event)"
                          autogrow
                          rows="2"
                          id="description"
                          class="block w-full mt-2 mb-2 description-textarea text-gray-900 bg-gray-50 rounded-lg border-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 overflow-y-auto"
                          placeholder="Write your thoughts here..."
                        ></textarea>
                      }
                    </div>
                  }@else {
                    <div [ngClass]="{'table-item-view': service?.desc && service?.desc !== ''}" class="max-w-full cursor-default mt-2" [class.mb-1]="service?.qbItem?.qbId && service?.type !== 'LABOR'" [class.mb-2]="!(service?.qbItem?.qbId && service?.type !== 'LABOR')">
                      <p class="table-description break-all">{{service?.desc}}</p>
                    </div>
                  }
                  <!-- QuickBooks item the row is linked to -->
                  @if(service?.qbItem?.qbId && service?.type !== 'LABOR'){
                    <div class="qb-item-badge" [class.qb-item-badge-read]="selectedService?._id != service?._id" [class.qb-item-badge-missing]="qbMissingIds().has(service.qbItem.qbId)" [title]="service.qbItem.name || ''">
                      <i class="fa-solid fa-box"></i>
                      <span>{{ service.qbItem.sku || service.qbItem.name || 'QuickBooks item' }}</span>
                      @if(qbMissingIds().has(service.qbItem.qbId)){
                        <span>· not in QuickBooks anymore</span>
                      }
                    </div>
                  }
                </td>
                <td class="table-qty not-drag">
                  @if(selectedService?._id == service?._id){
                    <div (click)="handleClick($event)">
                      <app-input
                        [type]="'number'"
                        [label]="service?.type==='LABOR'?'Hours':'Quantity'"
                        [value]="$safeNavigationMigration(service?.qty)"
                        (onChange)="updateService({_id:service._id, qty: $event, rate: service?.rate || 0, amount: $event * (service.rate || 0)});
                          service.qty = $event;
                          service.rate = service?.rate || 0;
                          service.amount = $event * (service.rate || 0); countAmounts(services())
                        "
                        [debounceEnable]="true"
                        [options]="{borderNone: true}"
                        [debounceTime]="800"
                        [disableValidation]="true"
                        [hightLightIfNotEmpty]="true"
                        [idInfo]="'service-qty'"
                      ></app-input>
                    </div>
                  }@else {
                    <div class="table-qty-wr table-item-view cursor-default">
                      <span>{{service?.qty}}</span>
                      <span>{{service?.type==='LABOR'?'Hours':'Quantity'}}</span>
                    </div>
                  }

                </td>
                <td class="service-price-table not-drag">
                  <div [ngClass]="{'table-item-view cursor-default': selectedService?._id !== service?._id}">
                    <app-price
                      [idInfo]="$safeNavigationMigration(service?._id)+'rate'"
                      [options]="{borderNone: true}"
                      (onSave)="updateService({_id:service._id,rate:$event, qty: service?.qty||1, amount: $event *  (service.qty || 1)});
                        service.rate = $event;
                        service.qty = service?.qty || 1;
                        service.amount = $event *  (service.qty || 1); countAmounts(services())
                      "
                      (click)="selectedService?._id == service?._id ? handleClick($event) : null"
                      [value]="$safeNavigationMigration(service?.rate)"
                      [label]="'Rate'"
                      [debounceEnable]="true"
                      [debounceTime]="600"
                      [isReadOnly]="selectedService?._id !== service?._id || locked"
                      [readView]="selectedService?._id !== service?._id || locked"
                    ></app-price>
                  </div>
                </td>
                <td class="service-price-table not-drag">
                  <div [ngClass]="{'table-item-view cursor-default': selectedService?._id !== service?._id}">
                    <app-price
                      [idInfo]="$safeNavigationMigration(service?._id)+'amount'"
                      [options]="{borderNone: true, readWarning: isZeroNewPart(service) ? 'This part has a $0 amount, so it won\'t be included in the QuickBooks invoice.' : null}"
                      (onSave)="updateService({_id:service._id,amount:$event, qty: service?.qty||1, rate: mathFloor($event / (service.qty || 1))});
                        service.amount = $event;
                        service.qty = service?.qty || 1;
                        service.rate = mathFloor($event / (service.qty || 1)); countAmounts(services())
                      "
                      (click)="selectedService?._id == service?._id ? handleClick($event) : null"
                      [value]="$safeNavigationMigration(service?.amount)"
                      [debounceEnable]="true"
                      [debounceTime]="600"
                      [isReadOnly]="selectedService?._id !== service?._id || locked"
                      [readView]="selectedService?._id !== service?._id || locked"
                      [label]="'Amount'"
                    ></app-price>
                  </div>
                </td>
                <td class="table-mechanic not-drag">
                  @if(selectedService?._id == service?._id){
                    <div (click)="handleClick($event)">
                      @if(service?.mechanic?._id){
                        <app-input
                          [value]="$safeNavigationMigration(service?.mechanic?.name)"
                          [options]="{canRemove: true, borderNone: true}"
                          (onSave)="updateService({_id:service._id, qty: $event})"
                          (onRemove)="setServiceMechanic(null, service); service.mechanic = null"
                          [disabled]="true"
                        ></app-input>
                      }@else {
                        <app-search
                          [idInfo]="$safeNavigationMigration(service?._id)"
                          [label]="'Mechanic'"
                          [resource]="'CONTACT'"
                          [options]="{borderNone: true, appendToBody: true}"
                          [isReadOnly]="locked"
                          [method]="'search'"
                          [filter]="{accountId: $safeNavigationMigration(currentUser?.company?._id), type: 'MECHANIC', limit: 25, sort: 'quoteCount', dir: 'desc', active: true}"
                          (onChange)="setServiceMechanic($event, service); service.mechanic = $event"
                        ></app-search>
                      }
                    </div>
                  }@else {
                    <div class="flex items-center table-mechanic-wr cursor-default">
                      <i class="fa-solid" [ngClass]="[service?.mechanic?._id ? 'fa-wrench' : 'fa-plus']"></i>
                      <p class="whitespace-nowrap">{{service?.mechanic?._id ? service?.mechanic?.name : 'Assign mechanic'}}</p>
                    </div>
                  }

                </td>
                <td class="table-unit not-drag">

                  @if(selectedService?._id == service?._id){
                    <div (click)="handleClick($event)">
                      <app-select
                        [keyName]="{key:'_id', name:'name'}"
                        [list]="$safeNavigationMigration(currentShopOrder?.unit)"
                        [value]="$safeNavigationMigration(service?.unit?._id)"
                        [options]="{noFirstOption: true, borderNone: true, appendToBody: true}"
                        (onSave)="updateUnit({_id:service._id, value: $event});"
                      ></app-select>
                    </div>
                  }@else {
                    <div class="flex items-center table-unit-wr cursor-default">
                      @if(service?.unit?._id){
                        <i class="fa-solid {{service?.unit?.unitType === 'TRUCK'?'fa-truck':'fa-trailer'}}"></i>
                      }@else {
                        <i class="fa-solid fa-plus"></i>
                      }
                      <p class="whitespace-nowrap">{{service?.unit?._id ? service?.unit?.name : 'Select Unit'}}</p>
                    </div>
                  }
                </td>
                <td class="not-drag service-cell-icon">
                  <div (click)="selectedService?._id == service?._id || !canUpdate ? handleClick($event) : null" [ngClass]="{'edit_file_btn': selectedService?._id == service?._id || !canUpdate, 'import_file cursor-default': selectedService?._id !== service?._id}">
                    <button (click)="selectedService?._id == service?._id || !canUpdate ? openPreview(service) : null" [ngClass]="{'cursor-default': selectedService?._id !== service?._id}" class="relative">
                      <i class="fa-solid fa-file-import"></i>
                      @if(service?._fileCount){
                        <span class="count">{{service?._fileCount}}</span>
                      }
                    </button>
                  </div>
                </td>
              </tr>
            }@empty {
              <!-- !!! Change all table to div's !!! -->
              <tr class="no-services-row">
                <td colspan="13">
                  <p style="font-size: 12px;" class="text-gray-500 ml-[10px]">No services</p>
                </td>
              </tr>
            }
          }
        </tbody>
        <tfoot>
          @if(currentShopOrder?._id && _services()?.length < 100){
            <tr class="not-drag">
              <td class="add-new-service-wr" colspan="13">
                @if(!locked){
                  <button class='text-gray-500 add-new-service' *appHasPermission="'shop_update'" type="submit" (click)="addService()" [ngClass]="{'not-allowed': !currentShopOrder?.unit?.length}"  [disabled]="!currentShopOrder?.unit?.length">
                    + New Service
                  </button>
                }
                @if(!currentShopOrder?._units?.length){
                  <span class="service-notify">Please select the unit!</span>
                }
              </td>
            </tr>
          }
        </tfoot>
      </table>

      @if(!currentShopOrder?._id){
        <div class="w-100 py-2">
          <app-preloader [type]="'CONTENT_LIST'" [count]="3"></app-preloader>
        </div>
      }
      <div class="contact-containers">
        <div class="notes-cont items" [ngClass]="locked ? 'isLocked' : ''">
          @if(currentShopOrder?._id){
            <app-notes
              [options]="{ list: true }"
              [creator]="currentUser"
              [usersEntities]="users"
              [title]="'Notes'"
              [display]="{
                tabs: { notes: true },
                select: {
                assignee: true,
                visibility: true,
                date: true,
                typeTask: true,
                complete: true,
                title: 'Service Notes'
                }
              }"
              [creator]="currentUser"
              [isReadOnly]="locked"
              [resource]="FOLLOW_UP_RESOURCE.SHOP_ORDER"
              [resourceId]="$safeNavigationMigration(currentShopOrder?._id)"
            ></app-notes>
          }@else {
            <div class="notes-block content-block block-shadow">
                <app-preloader [type]="'SMALL_LIST'" [count]="1"></app-preloader>
                <div class="mt-2">
                    <app-preloader [type]="'LARGE_LIST'" [count]="5"></app-preloader>
                </div>
            </div>
          }
        </div>
        <div class="filew-cont items">
          @if(currentShopOrder?._id){
            <app-files
              [title]="'Work Order files'"
              [lock]="locked || !canUpdate"
              [resource]="FOLLOW_UP_RESOURCE.SHOP_ORDER"
              [resourceId]="$safeNavigationMigration(currentShopOrder?._id)"
            ></app-files>
          }@else {
            <div class="notes-block content-block block-shadow">
                <app-preloader [type]="'SMALL_LIST'" [count]="2"></app-preloader>
                <div class="mt-2">
                    <app-preloader [type]="'LARGE_LIST'" [count]="2"></app-preloader>
                </div>
            </div>
          }
        </div>
        <div class="accouting-cont items">
          <p class="title">Accounting</p>
          @if(currentShopOrder?._id){
            <div class="accouting-cont-item">
              <p for="Invoice_number" class="block mb-2 subtitle font-medium text-gray-900 dark:text-white">Invoice number</p>
              <input [disabled]="locked || !canUpdate" (blur)="setAccounting('invoiceNumber', $any($event.target).value)" [value]="currentShopOrder?.accounting?.invoiceNumber && currentShopOrder?.accounting?.invoiceNumber !== 'undefined' ? currentShopOrder?.accounting?.invoiceNumber || '' : ''" type="text" id="Invoice_number" class="bg-gray-50 border-none text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Input number" required>
            </div>
            <div class="price-total-wr">
              <div class="item">
                <p class="subtitle">Total Parts</p>
                <div class="price-cont">
                  <app-price
                    [value]="totalParts"
                    [isReadOnly]="true"
                    [options]="{borderNone: true, medium: true, textBase: true }"
                    [icon]="'fa-solid fa-dollar-sign'"
                    (onSave)="setAccounting('amounts', {parts: $event, labor: $safeNavigationMigration(currentShopOrder?.accounting?.amounts?.labor) + 0})">
                  </app-price>
                </div>
              </div>
              <div class="item">
                <p class="subtitle">Total Labor</p>
                <div class="price-cont">
                  <app-price
                    [value]="totalLabors"
                    [isReadOnly]="true"
                    [options]="{borderNone: true, medium: true, textBase: true}"
                    [icon]="'fa-solid fa-dollar-sign'"
                    (onSave)="setAccounting('amounts', {labor: $event, parts: $safeNavigationMigration(currentShopOrder?.accounting?.amounts?.parts) + 0})">
                  </app-price>
                </div>
              </div>
            </div>
            <!-- Shop Fee lines of the order's QuickBooks invoices: invoice-only, never a service row -->
            @if(qbShowShopFee()){
              <div class="price-total-wr">
                <div class="item">
                  <p class="subtitle" title="Shop fee lines of all this order's QuickBooks invoices">Total Shop Fee</p>
                  <div class="price-cont">
                    <app-price
                      [value]="qbShopFeeTotal()"
                      [isReadOnly]="true"
                      [options]="{borderNone: true, medium: true, textBase: true}"
                      [icon]="'fa-solid fa-dollar-sign'">
                    </app-price>
                  </div>
                </div>
              </div>
            }
            <div class="price-total-wr">
              <div class="item">
                <p class="title">Grand Total</p>
                <div class="price-cont">
                  <app-price
                    [options]="{borderNone: true, medium: true, black: true, opatity: true, right: true, textBase: true }"
                    [readView]="true"
                    [value]="totalAmount + qbShopFeeTotal()">
                  </app-price>
                </div>
              </div>
            </div>
            <!-- QuickBooks invoices (shop QuickBooks connection, separate from freight) -->
            @let qbConnected = (quickBooksShopConnected$ | async);
            @let qbInvoices = (shopAccounts$ | async) || [];
            @let qbTruckCustomerLink = (qbCustomer$ | async);
            <!-- The customer of the order's current truck (the link can still be the previous truck's while it loads) -->
            @let qbTruckCustomer = qbTruckCustomerLink?.truck?._id === orderTruckId ? qbTruckCustomerLink?.qbCustomer : null;
            <!-- Companies without shop QuickBooks see nothing; disconnected, the invoices stay readable -->
            @if(qbConnected || qbInvoices.length){
            <div class="qb-invoices">
              <div class="qb-invoices-header">
                <p class="subtitle">QuickBooks invoices</p>
                @if(qbConnected && canUpdate){
                  <!-- An invoice bills the truck's QuickBooks customer: no truck or no customer, no invoice -->
                  <button type="button" class="qb-invoices-create"
                    [disabled]="locked || !orderTruckId || !qbTruckCustomer"
                    [title]="!orderTruckId ? 'Add a truck to the order to invoice it' : !qbTruckCustomer ? 'Choose the truck\'s QuickBooks customer first' : ''"
                    (click)="openQuickBooksInvoice()">
                    Create invoice
                  </button>
                }
              </div>
              @if(!qbConnected){
                <p class="qb-invoices-hint">QuickBooks is disconnected, so these invoices are read only.</p>
              }
              @for(invoice of qbInvoices; track invoice._id){
                <div class="qb-invoice-row" role="button" tabindex="0" (click)="openQuickBooksInvoice(invoice._id)" (keydown.enter)="openQuickBooksInvoice(invoice._id)">
                  <div class="qb-invoice-main">
                    <!-- QuickBooks' number only: an invoice it has no number for shows none -->
                    @if(invoice.docNumber){
                      <span class="qb-invoice-number">#{{invoice.docNumber}}</span>
                    }
                    <span class="qb-invoice-date">{{invoice.txnDate | date: 'MM/dd/yy'}}</span>
                  </div>
                  <div class="qb-invoice-main">
                    <span class="qb-invoice-amount">{{(invoice.amount || 0) / 100 | currency}}</span>
                    @if(invoice.balance && invoice.balance !== invoice.amount){
                      <span class="qb-invoice-date">Balance {{invoice.balance / 100 | currency}}</span>
                    }
                    <span class="qb-invoice-status" [attr.data-status]="invoice.status" [title]="invoice.sentAt ? 'Sent ' + (invoice.sentAt | date: 'MM/dd/yy h:mm a') : ''">{{(invoice.status || 'OPEN').replace('_', ' ').toLowerCase()}}</span>
                    <a class="qb-invoice-link" href="{{ qbUrl }}/app/invoice?txnId={{ invoice.qbId }}" target="_blank" rel="noopener"
                      title="Open in QuickBooks" (click)="$event.stopPropagation()">
                      <i class="fas fa-external-link-alt"></i>
                    </a>
                    @if(canUpdate && qbConnected){
                      <button type="button" class="qb-invoice-delete qb-invoice-sync" title="Sync from QuickBooks" [disabled]="qbSyncing().has(invoice._id)"
                        (click)="$event.stopPropagation(); syncQuickBooksInvoice(invoice)" (keydown.enter)="$event.stopPropagation()">
                        <i class="fa-solid fa-rotate" [class.fa-spin]="qbSyncing().has(invoice._id)"></i>
                      </button>
                    }
                    <!-- Paid invoices can't be deleted (the backend refuses too) -->
                    @if(canUpdate && qbConnected && !locked && invoice.status !== 'PAID' && invoice.status !== 'PARTIALLY_PAID'){
                      <button type="button" class="qb-invoice-delete" title="Delete invoice"
                        (click)="$event.stopPropagation(); deleteQuickBooksInvoice(invoice)" (keydown.enter)="$event.stopPropagation()">
                        <i class="fa-solid fa-trash-can"></i>
                      </button>
                    }
                  </div>
                </div>
              } @empty {
                <p class="qb-invoices-hint">No invoices yet.</p>
              }
            </div>
            }
          }@else {
            <div class="w-100 px-1 py-2">
              <app-preloader [type]="'LARGE_LIST'" [count]="4" [customHeight]="'40px'"></app-preloader>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>


